import React from 'react';
import './SubscriberSwiper.scss';
import DraggableTileGrid from '../DraggableTileGrid/DraggableTileGrid';
import SubscriberCard from '../SubscriberCard/SubscriberCard';
import {gaSelectCountriesTabIsClicked} from 'app/Components/Block/CellcomAbroadLobbyBlock/gaReports';
import {isMobile} from 'react-device-detect';
import {connect} from 'react-redux';
import SwiperCore, { Navigation } from 'swiper';

// Enable Navigation module
SwiperCore.use([Navigation]);

const SubscriberSwiper = ({
  subscribers = [],
  selectedSubscriber = null,
  onSubscriberSelect = () => {},
  onAddService = () => {},
  title = '',
  className = '',
  isUserSubscribed,
}) => {

  const handleSubscriberClick = (subscriber) => {
    onSubscriberSelect(subscriber);
  };

  const handleAddService = (subscriber) => {
    onAddService(subscriber);
  };
  

  return (
    <div className={`subscriber-swiper ${className}`}>
      <DraggableTileGrid
        items={subscribers}
        onItemClick={handleSubscriberClick}
        title={title}
        itemsPerColumn={1}
        columnWidth={isMobile ? 145 : 133}
        minColumnsInView={2}
        className='subscriber-grid'
        slidesOffsetAfter={16}
        enableNavigation={!isMobile && subscribers.length > 5}
        desktopSlidesPerView={5.7}
        customSpaceBetween={8}
        renderItem={(subscriber) => {
            const isSelected = selectedSubscriber && subscriber.cli === selectedSubscriber.cli;
            return (
              <SubscriberCard
                subscriberObj={subscriber}
                subscriberName={subscriber.fullName}
                phoneNumber={subscriber.cli}
                hasService={subscriber.hasService}
                isSelected={isSelected}
                onClick={(subscriber) => onSubscriberSelect(subscriber)}
                onAdd={(subscriber) => handleAddService(subscriber)}
              />
            );
          }}
      />
    </div>
  );
};


export default SubscriberSwiper;
